import { render, staticRenderFns } from "./Streak.vue?vue&type=template&id=274fe008&"
import script from "./Streak.vue?vue&type=script&lang=js&"
export * from "./Streak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports